import React, { Component } from 'react';
import { Route, Switch, Redirect } from 'react-router';
import { connect } from 'react-redux';

import { IdentityInit } from './init';
import { IdentityCode } from './code';

import IdentityationIlustration from './../../assets/images/placeholder/confirmation-ilustration.svg';

class IdentityIndex extends Component {
    render() {
        return (
            <main role="main" className="view flex-grow-1 pb-sm pb-xl-gutter" style={{ minHeight: "500px" }} >
                <div className="container-fluid container-modal m-auto h-inherit">
                    <section className="card card-body card-lg rounded-top-left-xl rounded-bottom-right-xl h-inherit shadow" >
                        <h4 className="sr-only visually-hidden">Registratio Compte</h4>
                        <div className="row justify-content-row gx-2 h-inherit">
                            <div className="col-12 col-lg h-inherit">
                                <img className="img-fluid img-contain container-md-wide mx-auto mt-4 my-lg-auto h-inherit" width="480" src={IdentityationIlustration} alt="Assist@" />
                            </div>
                            <Switch>
                                <Route path="/auth/identity/init" component={IdentityInit} />
                                <Route path="/auth/identity/code" component={IdentityCode} />

                                <Route render={() => {
                                    return <Redirect to="/auth/identity/init" />;
                                }} />
                            </Switch>
                        </div>
                    </section>
                </div>
            </main>
        );
    }
}

const mapStateToProps = (state) => ({
    example: state.example,
});
const mapDispatchToProps = {

};

export default connect(mapStateToProps, mapDispatchToProps)(IdentityIndex);